<template>
  <!-- <div class="navMenu">
    <label v-for="(navMenu, index) in navMenus" :key="index"> -->
      <!--只有一级菜单-->
      <el-menu-item
        v-if="itemData.haveChild === 0 && itemData.isMenu === 1"
        :index="itemData.route"
        @click="setPermission(itemData)"
      >
        <!--图标-->
        <i :class="'font_family' + ' ' + itemData.icon"></i>
        <!--标题-->
        <span slot="title">{{ itemData.menuName }}</span>
      </el-menu-item>
      <!--有多级菜单-->
      <el-submenu
        v-else-if="itemData.childList && itemData.haveChild === 1"
        :index="itemData.id.toString()"
      >
        <template slot="title">
          <i :class="'font_family' + ' ' + itemData.icon"></i>
          <span> {{ itemData.menuName }}</span>
        </template>
        <!--递归组件，把遍历的值传回子组件，完成递归调用-->
        <nav-menu v-for="item in itemData.childList" :key="item.id" :itemData="item"></nav-menu>
      </el-submenu>
    <!-- </label>
  </div> -->
</template>

<script>
export default {
  name: "NavMenu", //使用递归组件必须要有
  // props: ["navMenus"], // 传入子组件的数据
  props: ["itemData"],
  data() {
    return {
      indexVal: null
    };
  },
  methods: {
    setPermission(val) {
      localStorage.setItem('Permission', JSON.stringify(val.childList.length? val.childList:[val]))
      if(val.route === '/processManager/peopleOnline') {
        window.open(localStorage.getItem('companyMapUrl3'), '_blank')
        return
      }
      this.$store.commit('add_tabs', {route: val.route , name: val.menuName});
      this.$router.push(val.route)
      this.indexVal = val.id
    },
  },
};
</script>

<style>
.el-submenu__title:hover{
/* background-color: #2f53eb!important; */

}

</style>
<style scoped>


.el-menu-vertical-demo {
	text-align: left;
}
.el-menu {
	border-right: none;
}
.el-menu-item .font_family, .el-submenu .font_family{
	margin-right: 10px;
	/* color: white; */
}
.el-menu-item.is-active {
  /*background-color: #1d2041 !important;*/
  /* background-color: #2f53eb!important; */
  background-color: transparent;
}
.el-submenu .el-menu-item{
  background-color: #1f2d3d!important;
}
.el-menu-item:focus, .el-menu-item:hover {
/* background-color: #2f53eb!important; */
background-color: #001528!important;
}


.leftNavBox /deep/ .el-icon-arrow-down:before {
	content: "\E6DF";
	color: #ffffff;
}
</style>
